export * from 'store/bolt/header.js';
// import * as base from 'store/bolt/header.js';
import Store from 'store/store';

Store.on('HEADER_BG_VIDEO_PAUSED', (isPaused) => {
	Store.get().set({
		headerBgVideoPaused: isPaused
	});
});

